<app-page-layout
  [title]="titleTranslationKey | translate : { entity: ('market_discovery.' + entity + '.entity.name' | translate) }"
  backRoute="../">
  <app-page-buttons actions>
    <cap-button icon="fas fa-xmark" [label]="'button.cancel' | translate" (click)="cancel()" styleClass="secondary">
    </cap-button>

    <cap-button icon="fas fa-save" [label]="'button.submit' | translate" (click)="submit()" styleClass="primary">
    </cap-button>
  </app-page-buttons>

  <div class="row" content>
    <div class="col-lg-6">
      <cap-card [title]="'market_discovery.' + entity + '.entity.name' | translate">
        <ng-template capTemplate="content">
          <cpb-form-renderer
            [formKey]="formKey"
            [showHeader]="false"
            [context]="{ isEdit: true }"
            [modelId]="modelId"
            class="meta-detail">
          </cpb-form-renderer>
        </ng-template>
      </cap-card>
    </div>
  </div>
</app-page-layout>
